module.exports = __webpack_public_path__ + "3aa462f25817a7fc2c284b1f2a0b72a3.MP3";